module.exports = __webpack_public_path__ + "static/imagem-orcamento-equipamentos-f640eaff64cae1f664ecdcb393af2042.jpg";